import { ITextAreaStyle } from "../../../../base/domain/drawing";
import {
  IFontSizeAutoAdjustBehavior,
  ILineBreakBehaviorSpecifiable, instanceOfILineBreakBehaviorSpecifiable
} from "../../../../documaker/domain/format/objects";
import { ITextPresentableObject, instanceOfITextPresentableObject } from "./ITextPresentableObject";
import { ElementTypes } from "./ElementTypes";

export interface ITextDrawableObject extends ITextPresentableObject, ILineBreakBehaviorSpecifiable {
  textStyle: ITextAreaStyle;
  fontSizeAutoAdjustBehavior: IFontSizeAutoAdjustBehavior;
}

export function instanceOfITextDrawableObject<T extends ITextDrawableObject>(instance: any, type: ElementTypes): instance is ITextDrawableObject {
  return instance
      && instance.textStyle
      && instance.fontSizeAutoAdjustBehavior
      && instanceOfILineBreakBehaviorSpecifiable(instance)
      && instanceOfITextPresentableObject<T>(instance, type);
}
